import { Create, SimpleForm, TextInput, CheckboxGroupInput, useGetList, required } from 'react-admin';
import { Box } from '@mui/material';
import { layout } from '../styles/ds';

const WorkerCreate = () => {
  const { data: roles = [] } = useGetList('worker_roles', {
    pagination: { page: 1, perPage: 100 },
    sort: { field: 'name', order: 'ASC' },
  });

  const roleChoices = roles.map(r => ({ id: r.id, name: r.name }));

  return (
    <Create title="עובד חדש">
      <SimpleForm>
        <Box sx={layout.formGrid}>
          <TextInput source="name"  label="שם העובד" fullWidth validate={required('שדה חובה')} />
          <TextInput source="phone" label="טלפון"    fullWidth />
        </Box>
        <CheckboxGroupInput source="role_ids" label="תפקידים" choices={roleChoices} row />
        <TextInput source="notes" label="הערות" multiline rows={3} fullWidth />
      </SimpleForm>
    </Create>
  );
};

export default WorkerCreate;
